import * as v from "valibot";

export const DIGEST_KINDS = ["feedUpdate", "recommendedArticles"] as const;

/** The token of a digest's unsubscribe link (`<userId>.<kind>.<signature>`), in the path so a one-click POST carries it. */
export const unsubscribeEmailRequest = {
  token: v.pipe(v.string(), v.minLength(1), v.maxLength(300)),
};

export const unsubscribeEmailResponse = {
  kind: v.picklist(DIGEST_KINDS),
};
